import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { initCardStackAnimationIndividual } from "./stackcard.js";
import { scrollContent, initScrollBackgroundTransition } from "../gsap.js";
import gsap from 'gsap';

// Register GSAP plugin if not already
gsap.registerPlugin(ScrollTrigger);

// Debounce function
function debounce(func, wait = 200) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

// Resize handler
function handleResize() {
  //console.log('Resizing... Refreshing ScrollTrigger & animations');
  
  
  initCardStackAnimationIndividual();
  scrollContent();
  initScrollBackgroundTransition();

  // Refresh ScrollTrigger
  ScrollTrigger.refresh(true);

}

// Initialize watcher
export function initResizeWatcher() {
  window.addEventListener('resize', debounce(handleResize, 250));
}
